import { createContext, useEffect, useReducer } from "react";
import { types } from "./types";
import { UserReducer } from "./UserReducer";

const initialState = {
  user: null,
};

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(UserReducer, initialState);
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("data"));
    dispatch({
      type: types["[Reselect]"],
      payload: user,
    });
  }, [dispatch]);

  return (
    <UserContext.Provider value={{ state, dispatch }}>
      {children}
    </UserContext.Provider>
  );
};
